import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found-component/not-found.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: ()=> import('./landing/landing.component').then(m=>m.LandingComponent),
  },
  {
    path: 'founder-message',
    loadComponent: ()=> import('./founder-message/founder-message.component').then(m=>m.FounderMessageComponent),
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: '/404',
    pathMatch: 'full',
  },
];